"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _reactModal = _interopRequireDefault(require("react-modal"));

var _overrides = require("../../../utils/overrides");

var _Text = _interopRequireDefault(require("../../typography/Text"));

var _Icon = _interopRequireDefault(require("../../general/Icon"));

var _Button = _interopRequireDefault(require("../../general/Button"));

var _styles = require("../../../utils/styles");

var _styles2 = _interopRequireDefault(require("./styles"));

var useStyles = (0, _styles.createUseStyles)(_styles2.default, 'Modal');
var SIZES = {
  small: 400,
  medium: 670,
  large: 875
};

function Modal(_ref) {
  var children = _ref.children,
      classesProp = _ref.classes,
      overridesProp = _ref.overrides,
      classNameProp = _ref.className,
      overlayClassName = _ref.overlayClassName,
      title = _ref.title,
      isOpen = _ref.isOpen,
      useCornerClose = _ref.useCornerClose,
      useHeader = _ref.useHeader,
      size = _ref.size,
      width = _ref.width,
      cancelText = _ref.cancelText,
      confirmText = _ref.confirmText,
      onCancel = _ref.onCancel,
      onConfirm = _ref.onConfirm,
      onAfterOpen = _ref.onAfterOpen,
      onRequestClose = _ref.onRequestClose,
      shouldCloseOnEsc = _ref.shouldCloseOnEsc,
      shouldCloseOnOverlayClick = _ref.shouldCloseOnOverlayClick,
      closeTimeoutMS = _ref.closeTimeoutMS,
      props = (0, _objectWithoutProperties2.default)(_ref, ["children", "classes", "overrides", "className", "overlayClassName", "title", "isOpen", "useCornerClose", "useHeader", "size", "width", "cancelText", "confirmText", "onCancel", "onConfirm", "onAfterOpen", "onRequestClose", "shouldCloseOnEsc", "shouldCloseOnOverlayClick", "closeTimeoutMS"]);
  var classes = (0, _overrides.useClasses)(useStyles, classesProp); // Overrides

  var override = (0, _overrides.getOverrides)(overridesProp, Modal.overrides); // Classes

  var rootClassName = (0, _classnames.default)(classes.root, classNameProp);
  var overlayClassNames = (0, _classnames.default)(classes.overlay, overlayClassName);
  var contentStyle = {
    width: width || SIZES[size],
    top: '50%',
    left: '50%',
    right: 'auto',
    bottom: 'auto',
    marginRight: '-50%',
    transform: 'translate(-50%, -50%)'
  };
  var rootProps = (0, _extends2.default)({
    ariaHideApp: false,
    isOpen: isOpen,
    style: {
      content: contentStyle
    },
    overlayClassName: overlayClassNames,
    onAfterOpen: onAfterOpen,
    onRequestClose: onRequestClose,
    shouldCloseOnOverlayClick: shouldCloseOnOverlayClick,
    shouldCloseOnEsc: shouldCloseOnEsc,
    closeTimeoutMS: closeTimeoutMS
  }, override.root);
  var showFooter = onConfirm || onCancel;
  return /*#__PURE__*/_react.default.createElement(_reactModal.default, (0, _extends2.default)({
    className: rootClassName
  }, rootProps), useHeader && /*#__PURE__*/_react.default.createElement("div", (0, _extends2.default)({
    className: classes.header
  }, override.header), /*#__PURE__*/_react.default.createElement(_Text.default, (0, _extends2.default)({
    size: "big",
    className: classes.title
  }, override.title), title), useCornerClose && /*#__PURE__*/_react.default.createElement(_Icon.default, (0, _extends2.default)({
    size: "medium",
    name: "close",
    className: classes.closeIcon,
    onClick: onRequestClose
  }, override.closeIcon))), /*#__PURE__*/_react.default.createElement("div", (0, _extends2.default)({
    className: classes.content
  }, override.content), children), showFooter && /*#__PURE__*/_react.default.createElement("div", (0, _extends2.default)({
    className: classes.footer
  }, override.footer), onCancel && /*#__PURE__*/_react.default.createElement(_Button.default, (0, _extends2.default)({
    className: classes.cancelButton,
    onClick: onCancel
  }, override.cancelButton), cancelText), onConfirm && /*#__PURE__*/_react.default.createElement(_Button.default, (0, _extends2.default)({
    color: "primary",
    className: classes.confirmButton,
    onClick: onConfirm
  }, override.confirmButton), confirmText)));
}

Modal.overrides = ['root', 'title', 'header', 'content', 'footer', 'closeIcon', 'cancelButton', 'confirmButton'];
Modal.defaultProps = {
  size: 'medium',
  shouldCloseOnOverlayClick: true,
  shouldCloseOnEsc: true,
  useCornerClose: true,
  useHeader: true,
  closeTimeoutMS: 300
};
process.env.NODE_ENV !== "production" ? Modal.propTypes = {
  className: _propTypes.default.string,
  overlayClassName: _propTypes.default.string,
  overrides: _propTypes.default.object,
  children: _propTypes.default.any,
  title: _propTypes.default.string,
  isOpen: _propTypes.default.bool.isRequired,
  width: _propTypes.default.string,
  size: _propTypes.default.oneOf(['small', 'medium', 'large']),
  onCancel: _propTypes.default.func,
  onConfirm: _propTypes.default.func,
  confirmText: _propTypes.default.string,
  cancelText: _propTypes.default.string,

  /** Function that will be called after the drawer has opened */
  onAfterOpen: _propTypes.default.func,

  /** Function that will be called when the drawer is requested to be closed (either by clicking on overlay or pressing ESC) */
  onRequestClose: _propTypes.default.func,

  /** Close on overlay click, you must implement onRequestClose. */
  shouldCloseOnOverlayClick: _propTypes.default.bool,

  /** Close on ESC, you must implement onRequestClose. */
  shouldCloseOnEsc: _propTypes.default.bool,

  /** Show corner close icon. */
  useCornerClose: _propTypes.default.bool,

  /** Show header section */
  useHeader: _propTypes.default.bool,
  closeTimeoutMS: _propTypes.default.number
} : void 0;

var _default = /*#__PURE__*/_react.default.memo(Modal);

exports.default = _default;